module.exports = __webpack_public_path__ + "img/cy 2.b203474d.svg";